/* Pregnancy Week Calculator — Glamix Maternity · logic only */
/* UPLOAD TO: Assets/  (filename must be: pregnancy-week-calculator.js) */
(function () {
  function init() {
    var root = document.getElementById('glm-pwc');
    if (!root) return;
    var mode = 'lmp';
    var tabs = root.querySelectorAll('.tab');
    var lbl = root.querySelector('#glmLabel');
    var hint = root.querySelector('#glmHint');
    var inp = root.querySelector('#glmDate');
    var res = root.querySelector('#glmRes');
    var err = root.querySelector('#glmErr');
    var L = {
      lmp: ['First day of your last period', "Not sure? Use your best estimate \u2014 you can adjust later."],
      conception: ['Date of conception', "Roughly when you think you conceived."],
      due: ['Your estimated due date', "The due date your provider gave you."]
    };
    var SIZES = {4:['\uD83C\uDF31','a poppy seed'],5:['\u2022','a sesame seed'],6:['\uD83E\uDEDB','a lentil'],7:['\uD83E\uDED0','a blueberry'],8:['\uD83E\uDED8','a kidney bean'],9:['\uD83C\uDF52','a cherry'],10:['\uD83C\uDF53','a strawberry'],11:['\uD83E\uDED2','a fig'],12:['\uD83C\uDF4B','a lime'],13:['\uD83C\uDF4B','a lemon'],14:['\uD83C\uDF51','a peach'],15:['\uD83C\uDF4E','an apple'],16:['\uD83E\uDD51','an avocado'],17:['\uD83C\uDF60','a turnip'],18:['\uD83E\uDED1','a bell pepper'],19:['\uD83E\uDD6D','a mango'],20:['\uD83C\uDF4C','a banana'],21:['\uD83E\uDD55','a carrot'],22:['\uD83C\uDF48','a papaya'],23:['\uD83C\uDF4A','a grapefruit'],24:['\uD83C\uDF3D','an ear of corn'],25:['\uD83E\uDD6C','a cauliflower'],26:['\uD83E\uDD6C','a head of lettuce'],27:['\uD83E\uDD66','a cauliflower'],28:['\uD83C\uDF46','an eggplant'],29:['\uD83C\uDF83','a butternut squash'],30:['\uD83E\uDD6C','a cabbage'],31:['\uD83E\uDD65','a coconut'],32:['\uD83C\uDF83','a squash'],33:['\uD83C\uDF4D','a pineapple'],34:['\uD83C\uDF48','a cantaloupe'],35:['\uD83C\uDF48','a honeydew melon'],36:['\uD83E\uDD6C','romaine lettuce'],37:['\uD83C\uDF48','a winter melon'],38:['\uD83E\uDDC5','a leek'],39:['\uD83C\uDF83','a small pumpkin'],40:['\uD83C\uDF49','a watermelon']};
    function sizeFor(w){ if(w<4) return ['\u2728','a tiny cluster of cells']; if(w>40) return ['\uD83D\uDC76','a full-term baby']; return SIZES[w] || ['\uD83C\uDF50','a small pear']; }
    function shopFor(w){
      if(w<14) return ['Comfy bottoms for your early bump', [['Maternity Jeans','/collections/maternity-jeans','pri'],['Leggings','/collections/maternity-leggings','sec']]];
      if(w<28) return ['Time for your bump to shine', [['Photoshoot Gowns','/collections/photoshoot-dresses','pri'],['Baby Shower Dresses','/collections/baby-shower-dresses','sec']]];
      return ['Get ready to meet your baby', [['Shop Nursing','/collections/nursing','pri'],['Delivery Robes','/collections/delivery-robes','sec']]];
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        mode = t.dataset.mode;
        lbl.textContent = L[mode][0];
        hint.textContent = L[mode][1];
        res.classList.remove('show');
      });
    });
    function fmt(d){ return d.toLocaleDateString('en-US', { month:'long', day:'numeric', year:'numeric' }); }
    root.querySelector('#glmGo').addEventListener('click', function () {
      err.style.display = 'none';
      err.textContent = 'Please enter a valid date.';
      var v = inp.value;
      if (!v) { err.style.display = 'block'; return; }
      var picked = new Date(v + 'T00:00:00');
      if (isNaN(picked)) { err.style.display = 'block'; return; }
      var today = new Date(); today.setHours(0,0,0,0);
      var lmp, due;
      if (mode === 'lmp') { lmp = picked; }
      else if (mode === 'conception') { lmp = new Date(picked); lmp.setDate(lmp.getDate() - 14); }
      else { lmp = new Date(picked); lmp.setDate(lmp.getDate() - 280); }
      due = new Date(lmp); due.setDate(due.getDate() + 280);
      var ds = Math.floor((today - lmp) / 86400000);
      if (ds < 0 || ds > 308) { err.textContent = 'That date looks out of range \u2014 please double-check it.'; err.style.display = 'block'; return; }
      var wk = Math.floor(ds / 7), dy = ds % 7;
      var toGo = Math.max(0, Math.round((due - today) / 86400000));
      var tri = wk < 14 ? 'First trimester' : wk < 28 ? 'Second trimester' : 'Third trimester';
      var pct = Math.min(100, Math.max(0, (ds / 280) * 100));
      var sz = sizeFor(wk), sh = shopFor(wk);
      root.querySelector('#glmHead').innerHTML = "You're <b>" + wk + " weeks" + (dy ? " &amp; " + dy + (dy > 1 ? " days" : " day") : "") + "</b> pregnant";
      root.querySelector('#glmTri').textContent = tri;
      root.querySelector('#glmDue').textContent = fmt(due);
      root.querySelector('#glmDays').textContent = toGo + (toGo === 1 ? ' day' : ' days');
      root.querySelector('#glmEmoji').textContent = sz[0];
      root.querySelector('#glmSize').textContent = sz[1];
      root.querySelector('#glmPct').textContent = wk >= 40 ? 'Due now' : 'You are ' + Math.round(pct) + '% there';
      root.querySelector('#glmShopT').textContent = sh[0];
      root.querySelector('#glmShopB').innerHTML = sh[1].map(function (b) { return '<a class="' + b[2] + '" href="' + b[1] + '">' + b[0] + '</a>'; }).join('');
      res.classList.add('show');
      setTimeout(function () { root.querySelector('#glmBar').style.width = pct + '%'; }, 80);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();